<template>
  <div class="news">
    <!-- <div>
      <el-carousel class="carousel-box" height="516px">
        <el-carousel-item v-for="(item, index) in swiper" :key="index">
          <div class="carousel-img" :style="{'background-image': `url(${item})`}"></div>
        </el-carousel-item>
      </el-carousel>
    </div> -->
    <div
      class="container path"
      v-if="$route.path === '/superteacher' || $route.path === '/news'|| $route.path === '/recommendclass'|| $route.path === '/roomclass'"
    >
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.name}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="tab container">
      <el-container>
        <el-aside
          width="170px"
          v-if="$route.path === '/superteacher' || $route.path === '/news'|| $route.path === '/recommendclass'|| $route.path === '/roomclass'"
        >
        <el-card>
          <ul class="tab-type">
            <li>
              <router-link
                to="/recommendclass"
                :class="['nav-link', {'active': $route.path === '/recommendclass'}]"
              >推荐课程</router-link>
            </li>
            <li>
              <router-link
                to="/roomclass"
                :class="['nav-link', {'active': $route.path === '/roomclass'}]"
              >班级课程</router-link>
            </li>
            <li>
              <router-link
                to="/superteacher"
                :class="['nav-link', {'active': $route.path === '/superteacher'}]"
              >明星讲师</router-link>
            </li>
            <li>
              <router-link
                to="/news"
                :class="['nav-link', {'active': $route.path === '/news'}]"
              >新闻资讯</router-link>
            </li>
          </ul>
          </el-card>
        </el-aside>
        <el-container style="padding-left:20px">
          <router-view></router-view>
        </el-container>
      </el-container>
    </div>
  </div>
</template>
<script>
export default {
  name: "news",
  data() {
    return {
      index: "0",
      swiper: [
        "https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1589132010574&di=6da31690acc18c30238001a0b37508e7&imgtype=0&src=http%3A%2F%2Fa.img.youboy.com%2Fcoimg%2F2010%2F3%2F18%2Fg3_2461081.jpg",
        "http://00.minipic.eastday.com/20171012/20171012093130_c5d819710d4f442b3f6ee90a4a7e1d9e_1.jpeg",
        "http://attach.bbs.miui.com/forum/201401/11/145825zn1sxa8anrg11gt1.jpg"
      ]
    };
  },
  methods: {
    changeindex(index) {
      this.index = index;
      this.$router.push("/menu");
    }
  }
};
</script>
<style lang="less" scoped>
.carousel {
  height: 450px;
  position: relative;
  .carousel-box,
  /deep/ .el-carousel__container {
    height: 100%;
  }
}
.carousel-img {
  height: 100%;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}
.tab {
  overflow: hidden;
  padding-bottom: 40px;
}
.tab-type {
  
}
.tab-type li {
  width: 131px;
  cursor: pointer;
  height: 54px;
  line-height: 54px;
  text-align: center;
  margin: 0 auto;
  border-radius: 15px;
  margin-bottom: 15px;
  color: rgba(0, 0, 0, 1);
  font-size: 16px;
}
.tab-type li:last-child {
  margin-bottom: 0px;
}
.tab-cont {
  float: right;
  width: 975px;
}
.active {
  background-color: rgba(51, 119, 255, 0.2);
  color: rgba(51, 119, 255, 1) !important;
}
.path {
  color: rgba(166, 166, 166, 1);
  font-size: 16px;
  margin: 30px auto;
  overflow: hidden;
  a {
    display: block;
    line-height: 24px;
    height: 24px;
    float: left;
  }
  .path-to:hover {
    color: #0081e6;
  }
}
.go-icon {
  width: 24px;
  height: 24px;
}
.nav-link {
  display: block;
  text-decoration: none;
  border-radius: 15px;
  color: rgba(0, 0, 0, 1);
}
</style>